/* eslint-disable camelcase */
// import SalesAnalysisColumnDefinitionFactory from '@/app/sales_analysis/models/SalesAnalysisColumnDefinitionFactory'

export default class WeeklyComparativeAgGrid {
  constructor (weeklySalesComparativeGrid, normalMetric) {
    this.columnDefs = Object.keys(weeklySalesComparativeGrid.aggregation)
      .map(columnName => ({
        field: columnName,
        cellRendererFramework: 'AgGridCellFormatter',
        cellRendererParams: {
          formatType: normalMetric === 'quantity_sold' ? 'UNITS' : 'PESOS',
          infoFormatType: normalMetric === 'quantity_sold' ? 'UNITS_EXTENDED' : 'PESOS_EXTENDED'
        }
      }))
    this.data = weeklySalesComparativeGrid.data
    this.aggregation = [{ ...weeklySalesComparativeGrid.aggregation }]
  }
}



// WEBPACK FOOTER //
// ./src/app/weekly_sales/models/WeeklyComparativeAgGrid.js